import { Diff } from './components/Diff'
import { configuration } from './config/Configuration'
import type { Formatter } from './formatter'

export { Diff, Formatter, configuration }

